import { useEffect } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useUserContext } from "context/UserContext";
import { useNavigate } from "react-router-dom";
import Sidebar from "components/sidebar";
import useAutoRefresh from "hooks/useAutoRefresh";

const MainLayout = ({ children }) => {
  const { user } = useUserContext();
  const navigate = useNavigate();

  useAutoRefresh(); // Custom hook to handle token refresh

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [user]);

  return (
    <Flex minH={"100vh"}>
      <Sidebar />
      <Box flex={1} ml={"280px"}>
        {children}
      </Box>
    </Flex>
  );
};

export default MainLayout;
